export default "__VITE_ASSET__BKrCs3vA__"